import * as app from 'actions/AppActions';
import * as bank from 'actions/BankActions';
import * as businesses from 'actions/BusinessesActions';
import * as consumerPage from 'actions/ConsumerPageActions';
import * as csrfTokenActions from '@tock/shared/actions/CsrfTokenActions';
import * as feature from 'actions/FeatureActions';
import * as features from 'actions/FeaturesActions';
import * as finance from 'actions/FinanceActions';
import * as gifts from './GiftsActions';
import * as image from 'actions/ImageActions';
import * as importData from 'actions/ImportActions';
import * as importReport from 'actions/ImportReportActions';
import * as inventoryScheduleHistory from '@tock/shared/actions/InventoryScheduleHistoryActions';
import * as keyboardShortcuts from 'actions/KeyboardShortcutActions';
import * as menuMigrator from 'actions/MenuMigratorActions';
import * as metroArea from 'actions/MetroAreaActions';
import * as notifications from 'actions/NotificationActions';
import * as onboarding from 'actions/OnboardingActions';
import * as partners from 'actions/PartnerActions';
import * as patron from 'actions/PatronActions';
import * as patrons from 'actions/PatronsActions';
import * as paymentCard from '@tock/shared/actions/PaymentCardActions';
import * as phoneNumber from 'actions/PhoneNumberActions';
import * as scheduleHistory from 'actions/ScheduleHistoryActions';
import * as serviceEvents from 'actions/ServiceEventsActions';
import * as subscriptions from 'actions/SubscriptionActions';
import * as tockGiftCard from 'actions/TockGiftCardActions';
import * as verification from 'actions/VerificationActions';
import { actions as toast } from '@tock/toast';

export const actions = {
  app,
  bank,
  businesses,
  consumerPage,
  csrfTokenActions,
  feature,
  features,
  finance,
  gifts,
  image,
  import: importData,
  importReport,
  inventoryScheduleHistory,
  keyboardShortcuts,
  menuMigrator,
  metroArea,
  notifications,
  onboarding,
  partners,
  patrons,
  patron,
  paymentCard,
  phoneNumber,
  scheduleHistory,
  serviceEvents,
  subscriptions,
  toast,
  tockGiftCard,
  verification,
};
